export default __webpack_public_path__ + "static/media/mx.bc673581.svg";